module.exports = "/fonts/Ki.svg?451fd5bee09962b6977544325ace633f";